import React, { useEffect } from 'react';

const InstagramWidgetITW = () => {
  useEffect(() => {
    // Dynamically add the Elfsight platform script
    const script = document.createElement('script');
    script.src = 'https://static.elfsight.com/platform/platform.js';
    script.async = true;
    document.body.appendChild(script);

    // Cleanup to remove the script if the component is unmounted
    return () => {
      document.body.removeChild(script);
    };
  }, []);


  return (
    <div>
      {/* Include the Elfsight widget div */}
      <div
        className="elfsight-app-f99e4494-a72c-4326-819d-4c9b2ac7f378"
        data-elfsight-app-lazy
      ></div>
    </div>
  );
};

export default InstagramWidgetITW;
